import PDFContainer from '@Components/PreviewPDF/PDFContainer';
import { useFetchPdfPreview } from '@Domains/GeneratePDF';
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Flex from 'src/Components/Bases/Flex/Flex';

export const initialPdfHeight = 900;

const PreviewPDF = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const section = queryParams.get('section');
  const [activeLanguage, setActiveLanguage] = useState<'th' | 'en'>('th');
  const [height, setHeight] = useState<number>(initialPdfHeight);

  const [{ data, loading, error }] = useFetchPdfPreview(
    Number(id),
    activeLanguage,
    section ? section : ''
  );

  const generateFileName = () => {
    const currentDate = new Date().toISOString().split('T')[0];
    return `${section}_${activeLanguage}_${currentDate}`;
  };

  const handleChipClick = (language: 'th' | 'en') => {
    setActiveLanguage(language);
  };

  const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  let pdfData: string | undefined;
  if (data) {
    pdfData = `data:application/pdf;base64,${arrayBufferToBase64(data)}`;
  }

  const fileName = generateFileName();

  useEffect(() => {
    const updateHeight = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener('resize', updateHeight);

    updateHeight();

    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  if (loading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Alert severity={'error'}>
          ไม่สามารถโหลดข้อมูลแสดงตัวอย่างการตรวจสอบรายงาน Corporate Value upได้
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <Container sx={{ paddingBottom: 8 }}>
        <Typography variant="h2" my={4}>
          ตรวจสอบรายงาน Corporate Value Up
        </Typography>
        <Flex
          flexDirection="column"
          p={2}
          borderRadius={2}
          boxShadow={2}
          gap={1}
          mt={2}
          mb={4}
          bgcolor="white"
          height={Math.max(height, 900)}
        >
          {pdfData ? (
            <PDFContainer
              handleChipClick={handleChipClick}
              activeLanguage={activeLanguage}
              pdfData={pdfData}
              pdfName={fileName}
            />
          ) : (
            <Flex justifyContent="center" alignItems="center" height="100%">
              ไม่มีข้อมูล PDF
            </Flex>
          )}
        </Flex>
      </Container>
    </>
  );
};

export default PreviewPDF;
